export const getUserVotingRoomsQueryKey = () => ["userVotingRooms"];
